// src/components/chat/StreamingBanner.tsx
import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";

interface StreamingBannerProps {
  status?: string;
}

export const StreamingBanner: React.FC<StreamingBannerProps> = ({ status }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      px: 2.5,
      py: 1,
      bgcolor: "action.hover",
      borderTop: 1,
      borderColor: "divider",
    }}
  >
    <CircularProgress size={12} thickness={5} />
    <Typography variant="caption" color="text.secondary">
      {status || "Thinking…"}
    </Typography>
  </Box>
);
